import angular from 'angular';

import * as Constants from '../constants/statsbar';

/**
 * Sets the active component for the stats bar.
 * Options (optional) can include an onClose and onBefore hook.
 * Both hooks are executed as a promises, but can be regular functions as well.
 *
 * For example (do some work before showing the component then call another component on close):
 * dispatch(
 *   setActiveComponent('my-component', {
 *     onBefore: new Promise((resolve) => {
 *       console.log('do some work');
 *       setTimeout(() => {
 *         console.log('all done');
 *         resolve();
 *       }, 3000);
 *     }),
 *     onClose: () => {
 *       dispatch(setActiveComponent('some-other-component'));
 *     },
 *   }),
 * );
 *
 * @param {string} componentName - the name of the component to be displayed
 * @param {object} options - optional object containing onBefore and onClose hooks for the component
 * @returns {Promise}
 */

export const setActiveComponent = (componentName, options) => (dispatch, getStore) => {
  // get the on close function from the previous active component
  // and then clear it from the store
  const { onClose, closeRoute } = getStore().statsbar?.activeComponentOptions || {};
  dispatch({
    type: Constants.CLEAR_ACTIVE_COMPONENT_OPTIONS,
  });

  // call the onBefore function on the component that is mounting
  const onBefore = options && options?.onBefore;

  return new Promise((resolve) => {
    Promise.resolve(angular.isFunction(onBefore) && onBefore())
      .then(() => {
        // then call the onClose of the prior component
        if (angular.isFunction(onClose)) onClose();
        resolve(closeRoute);
      })
      .then(() => {
        // then set the next active component
        dispatch({
          type: Constants.SET_ACTIVE_COMPONENT,
          activeComponent: componentName,
          options,
        });
      });
  });
};
